/* eslint-disable */
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthProvider";
/* Importing Stylesheets */
import styles from "./style.module.scss";
/* Importing Images */
import CancoLogo from "../../../assets/cancoLogo.png";

const Sidebar = () => {
  const { userData, selectedProject } = useAuth();
  const navigate = useNavigate();

  return (
    <aside className={styles.sidebarContainer}>
      <figure onClick={() => navigate("/dashboard")}>
        <img src={CancoLogo} alt="Canco Logo" />
      </figure>
      <ul>
        {!selectedProject ? (
          <li>No project selected</li>
        ) : selectedProject.modules && selectedProject.modules.length > 0 ? (
          selectedProject.modules.map((module, moduleIndex) => {
            // let navLink =
            //   module.id === 1
            //     ? "locations"
            //     : module.id === 2
            //     ? "subAdmin"
            //     : module.id === 3
            //     ? "promotions"
            //     : module.id === 4
            //     ? "communityCare"
            //     : module.id === 5
            //     ? "webPromotions"
            //     : module.id === 7
            //     ? "banner"
            //     : module.id === 12
            //     ? "coffee-promotions"
            //     : module.id === 13
            //     ? "push-notification"
            //     : module.id === 14
            //     ? "carousel"
            //     : module.id === 16
            //     ? "propane-promotions"
            //     : module.id === 15
            //     ? "propane-popup"
            //     : null;
            return (
              <li key={`${selectedProject.id}-${module.id}`}>
                <NavLink to={module?.link || "#"}>{module.name}</NavLink>
              </li>
            );
          })
        ) : (
          <li>No modules available for this project</li>
        )}
      </ul>
    </aside>
  );
};

export default Sidebar;
